import { Box } from '@chakra-ui/react';
import { BaseTable } from '@cks-internal/react-base';
import { useWexCardTransactionColumns } from './hooks/useWexCardTransactionColumns';
import { WexCardTransaction, WexCardTransactionType } from './types';
import { useMemo } from 'react';

type Props = {
  transactions: WexCardTransaction[] | undefined;
  isLoading: boolean;
  isError: boolean;
  transactionTypeFilter?: WexCardTransactionType;
  tableHeight?: number;
};

export const WexCardTransactionTable = ({
  transactions,
  isLoading,
  isError,
  transactionTypeFilter,
  tableHeight
}: Props) => {
  const columns = useWexCardTransactionColumns();

  const filteredTransactions = useMemo(() => {
    if (transactionTypeFilter === undefined || !transactions) return transactions;

    return transactions.filter((transaction) => transaction.Type === transactionTypeFilter);
  }, [transactionTypeFilter, transactions]);

  if (isError || isLoading) {
    return null;
  }

  if (transactions?.length === 0) {
    return <Box>No transactions found for this card.</Box>;
  }

  return (
    <Box>
      <BaseTable
        disableGlobalFilter={true}
        stickyHeaders={tableHeight ? { tableHeight: [`${tableHeight}px`] } : undefined}
        data={filteredTransactions}
        columns={columns}
        isLoading={isLoading}
      />
    </Box>
  );
};
